<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17YigXV/tc-custom/9781460346471.jpg?1728169135767" alt="This image is the cover for the book In the Italian's Sights"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">In the Italian's Sights
      </h1>
      <p class="bookDescription body article font2">
        <p>An impossible temptation<br/><br/>Her fiancé has been stolen by her sister, she’s lost in the remote country lanes of Italy and her hire car has broken down! Wondering what else will go wrong, Cherry Gibbs looks up to meet the searing gaze of Vittorio Carella. Despite his having everything she has sworn to avoideasy charm and dazzling good-looksCherry finds herself staying at her rescuer’s villa. Soon she’s intoxicated by the stunning surroundings and seduced by Vittorio’s skilful touch. But this isn’t reality. Vittorio could have his pick of Italy’s social eliteso why has he set his sights on her?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Helen Brooks
      </h2>
      
      <p class="authorDescription body article">Helen Brooks began writing in 1990 as she approached her 40th birthday! She realized her two teenage ambitions (writing a novel and learning to drive) had been lost amid babies and hectic family life, so set about resurrecting them. In her spare time she enjoys sitting in her wonderfully therapeutic, rambling old garden in the sun with a glass of red wine (under the guise of resting while thinking of course). Helen lives in Northampton, England with her husband and family.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?570710c4